import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AppProvider } from '@/app/providers/AppProvider'
import { ProtectedRoute } from '@/app/router/guards/ProtectedRoute'
import { RoleBasedRouter } from '@/app/router/RoleBasedRouter'
import { SignIn } from '@/features/auth/components/SignIn'
import { SignUp } from '@/features/auth/components/SignUp'
import { Unauthorized } from '@/features/shared/components/Unauthorized'
import { NotificationToast } from '@/ui/components/molecules/NotificationToast'

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AppProvider>
        <NotificationToast />
        <Routes>
          {/* Public routes - no navigation */}
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          
          {/* Protected routes with navigation */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <RoleBasedRouter />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AppProvider>
    </Router>
  )
}

export default App